/**
 * @param memberships comes from userState and is stored as an array of strings (orgId_membershipStatus)
 * @param orgId organization whose membership we are searching for
 * */
export function isUserOrgMember(memberships, orgId) {
    return memberships.some((membership) => {
        const membershipOrgId = membership.split('_')[0];
        const membershipStatus = membership.split('_')[1];
        return membershipOrgId === orgId && membershipStatus !== 'withdrawn';
    });
}
